<template>
  <div>
    <div class="position-relative">
      <div class="profile-img-container d-flex align-items-center">
        <div
          class="profile-img d-flex flex-column justify-content-center align-items-center"
          v-b-modal.modal-seconday
          @click="visible = true"
          style="outline: none"
        >
          <b-img
            :src="userData.avatar || errorImage"
            @error="setAltImg"
            rounded
            fluid
            alt="profile photo"
            class="h-100"
          />
          <feather-icon icon="EditIcon" class="mr-auto" />
        </div>
        <div class="profile-title ml-3 mb-2 mb-sm-0">
          <h2 class="text-white">
            {{ userData.first_name + " " + userData.last_name }}
          </h2>
        </div>
      </div>
    </div>
    <b-modal
      :visible="visible"
      id="modal-seconday"
      modal-class="modal-secondary"
      centered
      title="تغییر عکس پروفایل"
    >
      <b-card-text class="d-flex justify-content-center align-items-center">
        <b-img
          thumbnail
          fluid
          :src="previewImg || errorImage"
          @error="setAltImg"
          alt="Image 1"
          width="120"
          height="120"
        ></b-img>
        <b-form-file
          class="mx-2"
          browseText="آپلود فایل"
          placeholder="فایلی انتخاب نشده است"
          dropPlaceholder="فایل را در این محل رها کنید"
          id="avatar"
          v-model="uploadFile"
          accept="image/jpeg, image/png, image/gif"
        />
      </b-card-text>
      <template #modal-footer>
        <b-button @click="onUploadFile"> ارسال </b-button>
      </template>
      <loader :loading="loading" />
    </b-modal>
  </div>
</template>

<script>
import {
  BImg,
  BCardText,
  BButton,
  BFormFile,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Loader from "@/@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BCardText,
    BButton,
    BImg,
    BFormFile,
    BModal,
    VBModal,
    Loader,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      uploadFile: null,
      previewImg: "",
      visible: false,
      loading: false,
    };
  },
  created() {
    this.previewImg = this.userData.avatar;
  },
  watch: {
    uploadFile(newVal) {
      this.previewImg = URL.createObjectURL(newVal);
    },
  },
  methods: {
    async onUploadFile() {
      if (this.uploadFile) {
        this.loading = true;
        let newFile = new FormData();
        newFile.append("avatar", this.uploadFile);
        newFile.append("_method", "patch");
        try {
          if (this.$route.params.id) {
            await this.$http.post(
              `/panel/users/${this.$route.params.id}/change-avatar`,
              newFile
            );
          } else {
            await this.$http.post(`/panel/profile/avatar`, newFile);
          }
          this.loading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "عکس پروفایل با موفقیت تغییر یافت",
                icon: "CheckIcon",
                variant: "success",
              },
            },
            { position: "bottom-right" }
          );
          this.$emit("updateUser");
          this.visible = false;
        } catch (err) {
          this.loading = false;
          this.visible = false;
        }
      }
    },
  },
};
</script>
<style  >
 .modal-header .close {
    margin: 0 !important;
}
</style>
